export default [
    //FOR BRANCH USER========================================================================
    {
        subject: "contractPR",
        key: "newContractPr", //this is the parameter found in the url /form/:key 
        pageTitle: "New Contract Purchase Request",
        editPage: "edit_form",  //the route to point when user select the add or edit button in the table
        previewPage: "view_form", //the route to point when user select the row in the table
        updateMainInfoWhenLoaded: { // this use to update the main info settings when user updated the PR item(add,update,delete)
            //we need to get the fresh data so that the total and subtotal is shown
            route: "contractpurchaserequests"

        },
        tableSettings: {
            route: "contractpurchaserequests",
            formType: "General",
            showItemPerPageOption: true,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            //if don't want to have filter empty this.we filter the table based on this value
            filter: {
                status: "New PR",
                userId: ""  //WE SET THIS ON FLY WHEN THE COMPONENT IS CALLED
            },
            filterEndpoint: "getContractPRbyUserIdAndStatus",
            showAddBtn: true,
            showActionButton: false, //if this is false the add and edit button will not be shown 
            showEditBtn: false,
            additionalData: {
                prStatus: "New PR",
                userId: "" // we set this on the fly
            }

        },
    },
    {
        subject: "contractPR",
        key: "Submitted HOD", //this is the parameter found in the url /form/:key 
        pageTitle: "PR Submitted to HOD",
        editPage: "edit_form",  //the route to point when user select the add or edit button in the table
        previewPage: "view_form", //the route to point when user select the row in the table
        updateMainInfoWhenLoaded: { // this use to update the main info settings when user updated the PR item(add,update,delete)
            //we need to get the fresh data so that the total and subtotal is shown
            route: "contractpurchaserequests"

        },
        tableSettings: {
            route: "contractpurchaserequests",
            formType: "General",
            showItemPerPageOption: true,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            //if don't want to have filter empty this.we filter the table based on this value
            filter: {
                status: "Submitted HOD",
                userId: ""  //WE SET THIS ON FLY WHEN THE COMPONENT IS CALLED
            },
            filterEndpoint: "getContractPRbyUserIdAndStatus",
            showAddBtn: false,
            showActionButton: false, //if this is false the add and edit button will not be shown 
            showEditBtn: false,
            additionalData: {
                prStatus: "Submitted HOD",
                userId: "" // we set this on the fly
            }

        },
    },
    {
        subject: "contractPR",
        key: "PO Generated", //this is the parameter found in the url /form/:key 
        pageTitle: "PR and PO is approved",
        editPage: "edit_form",  //the route to point when user select the add or edit button in the table
        previewPage: "view_form", //the route to point when user select the row in the table
        updateMainInfoWhenLoaded: { // this use to update the main info settings when user updated the PR item(add,update,delete)
            //we need to get the fresh data so that the total and subtotal is shown
            route: "contractpurchaserequests"

        },
        tableSettings: {
            route: "contractpurchaserequests",
            formType: "General",
            showItemPerPageOption: true,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            //if don't want to have filter empty this.we filter the table based on this value
            filter: {
                status: "PO Generated",
                userId: ""  //WE SET THIS ON FLY WHEN THE COMPONENT IS CALLED
            },
            filterEndpoint: "getContractPRbyUserIdAndStatus",
            showAddBtn: false,
            showActionButton: false, //if this is false the add and edit button will not be shown 
            showEditBtn: false,
            additionalData: {
                prStatus: "PO Generated",
                userId: "" // we set this on the fly
            }

        },
    },


    //----------------------------------------------------------------------------------------------
    //FOR HOD========================================================================================

    {
        subject: "contractPR",
        key: "HOD Pending Contract", //this is the parameter found in the url /form/:key 
        pageTitle: "Pending for Approval by HOD",
        editPage: "edit_form",  //the route to point when user select the add or edit button in the table
        previewPage: "view_form", //the route to point when user select the row in the table
        tableSettings: {
            route: "contractpurchaserequests", //the main route for CRUD
            formType: "General",
            showItemPerPageOption: true,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            //if don't want to have filter empty this.we filter the table based on this value
            filter: {
                status: "Submitted HOD",
                branchId: ""  //WE SET THIS ON FLY WHEN THE COMPONENT IS CALLED
            },
            filterEndpoint: "getContractPRByBranchAndStatus",
            showAddBtn: true,
            showActionButton: true, //if this is false the add and edit button will not be shown 
            showEditBtn: true,

        },
    },
    {
        subject: "contractPR",
        key: "HOD Approved Contract", //this is the parameter found in the url /form/:key 
        pageTitle: "PO Approved",
        editPage: "edit_form",  //the route to point when user select the add or edit button in the table
        previewPage: "view_form", //the route to point when user select the row in the table
        tableSettings: {
            route: "contractpurchaserequests", //the main route for CRUD
            formType: "General",
            showItemPerPageOption: true,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            //if don't want to have filter empty this.we filter the table based on this value
            filter: {
                status: "PO Generated",
                branchId: ""  //WE SET THIS ON FLY WHEN THE COMPONENT IS CALLED
            },
            filterEndpoint: "getContractPRByBranchAndStatus",
            showAddBtn: false,
            showActionButton: false, //if this is false the add and edit button will not be shown 
            showEditBtn: false,

        },
    },

    {
        subject: "contractPR",
        key: "HOD Rejected Contract", //this is the parameter found in the url /form/:key 
        pageTitle: "Rejected Contract PR",
        editPage: "edit_form",  //the route to point when user select the add or edit button in the table
        previewPage: "view_form", //the route to point when user select the row in the table
        tableSettings: {
            route: "contractpurchaserequests", //the main route for CRUD
            formType: "General",
            showItemPerPageOption: true,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            //if don't want to have filter empty this.we filter the table based on this value
            filter: {
                status: "Rejected by HOD",
                branchId: ""  //WE SET THIS ON FLY WHEN THE COMPONENT IS CALLED
            },
            filterEndpoint: "getContractPRByBranchAndStatus",
            showAddBtn: true,
            showActionButton: true, //if this is false the add and edit button will not be shown 
            showEditBtn: true,

        },
    },

    //----------------------------------------------------------------------------------------------


]